<template>

  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-4">
        <div class="form-group">
          <input
            type="text"
            autofocus
            class="form-control"
            v-model="search"
            @input="searchChange()"
            :placeholder="$t(`site.search`)"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="$mobile == 1" ref="table" class="vuetable" sort-by="id" sort-desc.sync="false"
          :current-page="currentPage" :fields="bootstrapTable.fields" :items="data">
          <template #cell(actions)="row">
            <div class="text-center">
              <b-button size="sm" variant="primary" @click="
                $router.push({
                  name: 'QuranScheduleDateSystemicv2',
                  params: { id: row.item.program_id },
                })
                ">
                <i class="fas fa-arrow-left"></i> الدخول للمقرأة
              </b-button>
            </div>
          </template>
        </b-table>
        <hr />

        <b-pagination v-model="currentPage" align="right" @input="onChangePage(currentPage)"
          class="dataTables_paginate paging_simple_numbers pagination-warning" :total-rows="totalRows"
          :per-page="perPage">
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>
        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
  </div>
</template>

<script>
import Auth from "@/Apis/Auth";
import controller from "../../../../Controllers/QuranProgramsWithUsers";

export default {
  name: "QuranProgramsDataTablev2",
  props: ["editItem", "type"],
  data() {
    return {
   
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [

          {
            key: "period",
            label: "الجزء",
            sortable: false,
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "alward",
            label: "الورد الجديد",
            sortable: false,
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "SaveType",
            label: "النوع",
            sortable: false,
            thClass: "text-center",
            tdClass: "text-center",
            formatter: (value) => {
              if (value === "asc") return "تصاعدي";
              if (value === "desc") return "تنازلي";
              return value;
            },
          },
          {
            key: "reading_type",
            label: "الرواية",
            sortable: false,
            thClass: "text-center",
            tdClass: "text-center",
            formatter: (value) => {
              if (value === 1) return "رواية حفص";
              if (value === 2) return "رواية ورش";
              return value;
            },
          },

          {
            key: "actions",
            label: "الإجراءات",
            sortable: false,
            thClass: "text-center",
            tdClass: "text-center",
          },
        ],
      },
      data: [],
      selectAll: false,

      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {
        filter: this.type == 'teacher' ? `teacher_id|${Auth.USER.id}` : `student_id|${Auth.USER.id}`,
      },
      recordIds: [],
    };
  },
  async created() {
    //

    this.dataProvider(this.params);
       if (this.type == 'teacher') {
          this.bootstrapTable.fields.unshift({
            key: "student_name",
            label: "اسم الطالب",
            sortable: false,
            thClass: "text-center",
            tdClass: "text-center",
          })
        }else{
          this.bootstrapTable.fields.unshift({
            key: "alward_Name",
            label: "اسم المقرأة",
            sortable: false,
            thClass: "text-center",
            tdClass: "text-center",
          })
        }
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      console.log(this.currentPage);
      this.params.currentPage = this.currentPage;
      if (this.$refs.table) this.$refs.table.refresh();
      this.dataProvider(this.params);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;

      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${this.params.sortDesc ? "desc" : "asc"
          }`;
      } else {
        apiParams.sort = "id|desc";
      }
      if (this.params.filter) {
        apiParams.filter = this.params.filter;
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }

      apiParams.with = [];

      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.params.currentPage = 1;
        this.dataProvider(this.params);
        if (this.$refs.table) this.$refs.table.refresh();
        return;
      }
      if (this.search.length < 2) return;
      this.params.currentPage = 1;
      this.dataProvider(this.params);
      if (this.$refs.table) this.$refs.table.refresh();
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
  },
};
</script>
